<div class="table-layout">
    <n-loading [visible]="loading"></n-loading>
    <div class="table-operation">
        <button nButton id="ip-white-list-refresh"
            style="float: right;"
            icon="icon-refresh"
            (click)="refresh()">
        </button>
        <n-button-group [relateTable]="dt"
            [items]="[addBtn, removeBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt
            id="ip-white-list-table"
            style="height: 4rem;"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs"
            [rest]="tableRest"
            [countRest]="tableCountRest"
            [simpleMode] = 'isSimpleMode'
            [(selection)]="selection">
        </n-data-table>
    </div>
</div>
